import React, { useState, useEffect } from 'react';
import { AlertTriangle, Wrench } from 'lucide-react';

const MaintenanceBanner = () => {
    const [maintenance, setMaintenance] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkMaintenance = async () => {
            try {
                const response = await fetch('/api/admin/maintenance');
                const data = await response.json();
                setMaintenance(data);
            } catch (error) {
                console.error('Error checking maintenance status:', error);
                setMaintenance({ enabled: false });
            } finally {
                setLoading(false);
            }
        };

        checkMaintenance();
        
        // Check every 30 seconds
        const interval = setInterval(checkMaintenance, 30000);
        return () => clearInterval(interval);
    }, []);

    if (loading || !maintenance?.enabled) {
        return null;
    }

    return (
        <div 
            className="fixed inset-0 z-100 flex items-center justify-center bg-black/60 backdrop-blur-xs"
            data-testid="maintenance-overlay"
        >
            <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 text-center">
                <div className="w-20 h-20 rounded-full bg-orange-100 flex items-center justify-center mx-auto mb-6">
                    <Wrench className="w-10 h-10 text-orange-600" />
                </div>
                
                <h1 className="text-2xl font-bold text-gray-900 mb-3">
                    Site în mentenanță
                </h1>
                
                <p className="text-gray-600 mb-6">
                    {maintenance.message || 'Site-ul este în mentenanță. Revenim în curând.'}
                </p>
                
                <div className="flex items-center justify-center gap-2 text-sm text-orange-600 bg-orange-50 rounded-lg py-3 px-4">
                    <AlertTriangle className="w-4 h-4" />
                    <span>Vă rugăm să reveniți mai târziu</span>
                </div>
            </div>
        </div>
    );
};

// Hook to check maintenance status for blocking actions
export const useMaintenanceCheck = () => {
    const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);

    useEffect(() => {
        const checkMaintenance = async () => {
            try {
                const response = await fetch('/api/admin/maintenance');
                const data = await response.json();
                setIsMaintenanceMode(data?.enabled || false);
            } catch {
                setIsMaintenanceMode(false);
            }
        };

        checkMaintenance();
        const interval = setInterval(checkMaintenance, 30000);
        return () => clearInterval(interval);
    }, []);

    const checkBeforeAction = async (action) => {
        try {
            const response = await fetch('/api/admin/maintenance');
            const data = await response.json();
            if (data?.enabled) {
                return { blocked: true, message: data.message || 'Site-ul este în mentenanță' };
            }
        } catch {
            // Allow action if check fails
        }
        return { blocked: false };
    };

    return { isMaintenanceMode, checkBeforeAction };
};

export default MaintenanceBanner;
